<div class="mb-4">
  <strong class="fs-3">Gestion de l'API</strong>
</div>

<admin-search-api></admin-search-api>

<admin-list-api [requests]="requests"></admin-list-api>
